import { CommonModule } from '@angular/common'
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'
import { PAGE_KEY } from '../../constants/page.constants'
import { VODLanguage, VODVideo } from '../../interfaces/vod'
import { MinutesToDurationPipe } from '../../pipes/minutes-to-duration.pipe'
import { VODService } from '../../services/vod.service'

@Component({
  selector: 'app-vod-summary',
  standalone: true,
  imports: [CommonModule, MinutesToDurationPipe],
  templateUrl: './vod-summary.component.html',
  styleUrls: ['./vod-summary.component.scss'],
})
export class VODSummaryComponent extends BaseWidgetComponent implements OnInit {
  vod?: VODVideo
  vodLang?: VODLanguage

  @ViewChild('container') containerEl!: ElementRef
  @ViewChild('description', { static: false }) descriptionEl?: ElementRef

  constructor(private vodService: VODService) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()

    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_VOD)?.subscribe((vod: VODVideo) => {
        this.vod = vod
        this.vodLang = this.vodService.getVODLang(this.vod)
      })
    )
  }

  override applyStyles(): void {
    super.applyStyles()
  }
}
